import { sessionHelper } from "@/utils";

const admins = [
  {
    path: "/profile",
    name: "Profile",
    meta: { permissions: [] },
    component: () => import("@/views/pages/admin/profile/main.vue"),
  },
  {
    path: "/",
    name: "Dashboard",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/dashboard/main.vue"),
  },
  {
    path: "/workplaces",
    name: "Workplace",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/workplace/main.vue"),
  },
  {
    path: "/meeting-room-management",
    name: "MeetingRoomManagement",
    meta: { permissions: [] },
    component: () =>
      import("@/views/pages/admin/meetingRoomManagement/main.vue"),
  },
  {
    path: "/meeting-rooms",
    name: "MeetingRoom",
    meta: { permissions: [] },
    component: () => import("@/views/pages/admin/meetingRoom/main.vue"),
  },
  {
    path: "/meeting-room-bookings",
    name: "MeetingRoomBooking",
    meta: { permissions: [] },
    component: () => import("@/views/pages/admin/meetingRoomBooking/main.vue"),
  },
  {
    path: "/configurations",
    name: "Configuration",
    meta: {
      permissions: ["configurations:read"],
    },
    component: () => import("@/views/pages/admin/configuration/main.vue"),
  },
  {
    path: "/groups",
    name: "Group",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/group/main.vue"),
  },
  {
    path: "/locations",
    name: "Location",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/location/main.vue"),
  },
  {
    path: "/countries",
    name: "Country",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/country/main.vue"),
  },
  {
    path: "/states",
    name: "State",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/state/main.vue"),
  },
  {
    path: "/recruitments",
    name: "Recruitment",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/recruitment/main.vue"),
  },
  {
    path: "/candidates",
    name: "Candidate",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/candidate/main.vue"),
  },
  {
    path: "/candidate-jobs",
    name: "CandidateJob",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/candidateJob/main.vue"),
  },
  {
    path: "/candidate-statuses",
    name: "CandidateStatus",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/candidateStatus/main.vue"),
  },
  {
    path: "/communications",
    name: "Communication",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/communication/main.vue"),
  },
  {
    path: "/articles",
    name: "Article",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/article/main.vue"),
  },
  {
    path: "/notifications",
    name: "Notification",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/notification/main.vue"),
  },
  {
    path: "/documents",
    name: "Document",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/document/main.vue"),
  },
  {
    path: "/article-categories",
    name: "ArticleCategory",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/articleCategory/main.vue"),
  },
  {
    path: "/notification-icons",
    name: "NotificationIcon",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/notificationIcon/main.vue"),
  },
  {
    path: "/notification-channels",
    name: "NotificationChannel",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/notificationChannel/main.vue"),
  },
  {
    path: "/document-categories",
    name: "DocumentCategory",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/documentCategory/main.vue"),
  },
  {
    path: "/catalogs",
    name: "Catalog",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/catalog/main.vue"),
  },
  {
    path: "/catalog-categories",
    name: "CatalogCategory",
    meta: { permissions: [] },
    component: () => import("@/views/pages/admin/catalogCategory/main.vue"),
  },
  {
    path: "/catalog-subcategories",
    name: "CatalogSubcategory",
    meta: { permissions: [] },
    component: () => import("@/views/pages/admin/catalogSubcategory/main.vue"),
  },
  {
    path: "/events",
    name: "Event",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/event/main.vue"),
  },
  {
    path: "/marketplaces",
    name: "Marketplace",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/marketplace/main.vue"),
  },
  {
    path: "/administrations",
    name: "Administration",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/administration/main.vue"),
  },
  {
    path: "/user-permission-definitions",
    name: "UserPermissionDefinition",
    meta: { permissions: [] },
    component: () =>
      import("@/views/pages/admin/userPermissionDefinition/main.vue"),
  },
  {
    path: "/user-roles",
    name: "UserRole",
    meta: { permissions: [] },
    component: () => import("@/views/pages/admin/userRole/main.vue"),
  },
  {
    path: "/esg-documents",
    name: "EsgDocument",
    meta: { permissions: [] },
    component: () => import("@/views/pages/admin/esgDocument/main.vue"),
  },
  {
    path: "/esg-documents/:documentUUID/users",
    name: "EsgDocumentUsers",
    meta: { permissions: [] },
    component: () => import("@/views/pages/admin/esgDocument/users.vue"),
  },
  {
    path: "/users/:userUUID",
    name: "UserDetails",
    props: true,
    meta: { permissions: [] },
    component: () => import("@/views/pages/admin/user/details.vue"),
  },
  {
    path: "/users",
    name: "User",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/user/main.vue"),
  },
  {
    path: "/properties",
    name: "Property",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/property/main.vue"),
  },
  {
    path: "/property-assets",
    name: "PropertyAsset",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/propertyAsset/main.vue"),
  },
  {
    path: "/property-tenants",
    name: "PropertyTenanted",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/propertyTenanted/main.vue"),
  },
  {
    path: "/property-asset-rentals",
    name: "PropertyAssetRental",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/propertyAssetTenant/main.vue"),
  },
  {
    path: "/property-actions",
    name: "PropertyAction",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/propertyAction/main.vue"),
  },
  {
    path: "/property-area-units",
    name: "PropertyAreaUnit",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/propertyAreaUnit/main.vue"),
  },
  {
    path: "/property-categories",
    name: "PropertyCategory",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/propertyCategory/main.vue"),
  },
  {
    path: "/property-statuses",
    name: "PropertyStatus",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/propertyStatus/main.vue"),
  },
  {
    path: "/property-tenures",
    name: "PropertyTenure",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/propertyTenure/main.vue"),
  },
  {
    path: "/property-types",
    name: "PropertyType",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/propertyType/main.vue"),
  },
  {
    path: "/companies/:companyUUID",
    name: "CompanyDetails",
    props: true,
    meta: { permissions: [] },
    component: () => import("@/views/pages/admin/company/details.vue"),
  },
  {
    path: "/companies",
    name: "Company",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/company/main.vue"),
  },
  {
    path: "/company-types",
    name: "CompanyType",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/companyType/main.vue"),
  },
  {
    path: "/departments",
    name: "Department",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/department/main.vue"),
  },
  {
    path: "/offices",
    name: "Office",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/office/main.vue"),
  },
  {
    path: "/office-types",
    name: "OfficeType",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/officeType/main.vue"),
  },
  {
    path: "/positions",
    name: "Position",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/position/main.vue"),
  },
  {
    path: "/reports",
    name: "Report",
    meta: { permissions: [] },
    component: () => import("@/views/pages/admin/report/main.vue"),
  },
  {
    path: "/sport-clubs",
    name: "SportClub",
    meta: { permissions: [] },
    component: () => import("@/views/pages/admin/sportClub/main.vue"),
  },
  {
    path: "/diagnostics",
    name: "Diagnostic",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/diagnostic/main.vue"),
  },
  {
    path: "/systems",
    name: "System",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/system/main.vue"),
  },
  {
    path: "/vehicles",
    name: "Vehicle",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/vehicle/main.vue"),
  },
  {
    path: "/panels",
    name: "Panels",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/panel/main.vue"),
  },
  {
    path: "/panel-types",
    name: "PanelType",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/panelType/main.vue"),
  },
  {
    path: "/orientations",
    name: "Orientation",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/orientation/main.vue"),
  },
  {
    path: "/certificates",
    name: "Certificate",
    meta: {
      permissions: ["cert_admin:read"],
    },
    component: () => import("@/views/pages/admin/certificate/main.vue"),
  },
  {
    path: "/orientation-modules",
    name: "OrientationModule",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/orientationModule/main.vue"),
  },
  {
    path: "/orientation-module-assignments",
    name: "OrientationModuleAssignment",
    meta: {
      permissions: [],
    },
    component: () =>
      import("@/views/pages/admin/orientationModuleAssignment/main.vue"),
  },
  {
    path: "/workgroups",
    name: "Workgroup",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/workgroup/main.vue"),
  },
  {
    path: "/phone-extensions",
    name: "PhoneExtension",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/admin/phoneExtension/main.vue"),
  },
];

const ihextars = [
  {
    path: "/",
    name: "Dashboard",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/ihextar/dashboard/main.vue"),
  },
  {
    path: "/meeting-room-bookings",
    name: "MeetingRoomBooking",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/ihextar/meetingRoomBooking/main.vue"),
  },
];

const publics = [
  {
    path: "/login",
    name: "login",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/public/login/login.vue"),
  },
  {
    path: "/jobs",
    name: "Jobs",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/public/candidateJob/main.vue"),
  },
  {
    path: "/applications",
    name: "CandidateApplication",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/public/candidate/candidateForm.vue"),
  },
  {
    path: "/application-errors",
    name: "CandidateApplicationError",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/public/candidate/candidateFormError.vue"),
  },
  {
    path: "/application-completes",
    name: "CandidateApplicationComplete",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/public/candidate/candidateFormComplete.vue"),
  },
  {
    path: "/employees/:candidateUUID?",
    name: "CandidateEmployee",
    props: true,
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/public/candidate/candidateEmployeeForm.vue"),
  },
  {
    path: "/panel",
    name: "Panel",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/public/panel/main.vue"),
  },
  {
    path: "/privacy-policy",
    name: "PrivacyPolicy",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/public/privacyPolicy/main.vue"),
  },
  {
    path: "/team-directory",
    name: "TeamDirectory",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/public/teamDirectory/main.vue"),
  },
  {
    path: "/team-directory/:id",
    name: "TeamDirectoryDetail",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/public/teamDirectory/teamDirectoryDetail.vue"),
  },
  {
    path: "/forgot-password",
    name: "ForgotPassword",
    meta: {
      permissions: [],
    },
    component: () => import("@/views/pages/public/login/forgotPassword.vue"),
  },
];

export const routes = [
  ...publics,
  ...(sessionHelper.getUserType() == "api" ? admins : []),
  ...(sessionHelper.getUserType() == "app" ? ihextars : []),
  {
    path: "*",
    name: "Not-found",
    component: () => import("@/views/pages/public/errors/404.vue"),
  },
];
